import { CellContext, ColumnDef } from '@tanstack/react-table'
import * as React from 'react'
import {
  NameCell,
  DescriptionCell,
  ProficiencyCell,
  PeopleCell,
  ActionsCell,
} from './cells'

export type UserWithProficiency = {
  userId: string
  proficiencyLevel: number | null
  source: 'implied' | 'assigned' | 'self_declared'
}

export type OrgPersonalSkillsTableRow = {
  id: string
  name: string
  description: string | null
  skillType: string | null
  userCount: number
  first3UserIds: string[]
  averageProficiency: number | null
  usersWithProficiency: UserWithProficiency[]
}

export class Data {
  get columns() {
    return [
      {
        accessorKey: 'name',
        cell: NameCell,
        enableGlobalFilter: true,
        header: 'Name',
        id: 'name',
        size: 280,
        minSize: 200,
      },
      {
        accessorKey: 'skillType',
        cell: this.renderSkillType,
        enableGlobalFilter: false,
        header: 'Skill type',
        id: 'skillType',
        filterFn: 'equals',
        size: 120,
      },
      {
        accessorKey: 'description',
        cell: DescriptionCell,
        enableGlobalFilter: true,
        header: 'Description',
        id: 'description',
        size: 300,
        minSize: 200,
      },
      {
        accessorKey: 'averageProficiency',
        cell: ProficiencyCell,
        enableGlobalFilter: false,
        header: 'Ave. proficiency',
        id: 'averageProficiency',
        sortingFn: 'alphanumeric',
        size: 140,
      },
      {
        accessorKey: 'userCount',
        cell: PeopleCell,
        enableGlobalFilter: false,
        id: 'users',
        header: 'People using',
        sortingFn: 'alphanumeric',
        size: 140,
      },
      {
        id: 'actions',
        enableGlobalFilter: false,
        cell: ActionsCell,
        size: 60,
      },
    ] satisfies ColumnDef<OrgPersonalSkillsTableRow, never>[]
  }

  private renderSkillType(
    row: CellContext<OrgPersonalSkillsTableRow, string | null>
  ) {
    const skillType = row.getValue()
    if (!skillType) return <span className="text-gray-400">-</span>
    const label =
      skillType.charAt(0).toUpperCase() + skillType.slice(1) + ' skill'
    return <span className="text-gray-600 text-sm">{label}</span>
  }
}
